/* eslint-disable */
/* THIS FILE HAS BEEN GENERATED DO NOT EDIT IT DIRECTLY */
import * as Types from '../../../../../graphql/__generated__/types';

import { gql } from '@apollo/client';
import * as ApolloReactCommon from '@apollo/client';
import * as ApolloReactHooks from '@apollo/client';
const defaultOptions = {} as const;
export type ConfigBookmarks_ConfigFragment = { __typename: 'ConfigurationModel', id: string, bookmarks: { __typename: 'ConfigBookmarks', all: { __typename: 'ConfigAllBookmarksState', reported?: Array<string> | null } } };

export type ConfigUpdateBookmarksMutationVariables = Types.Exact<{
  input: Types.ConfigurationUpdateBookmarksAllInput;
}>;


export type ConfigUpdateBookmarksMutation = { __typename: 'Mutation', configurationUpdateBookmarksAll: { __typename: 'ConfigurationModel', id: string, bookmarks: { __typename: 'ConfigBookmarks', all: { __typename: 'ConfigAllBookmarksState', reported?: Array<string> | null } } } };

export const ConfigBookmarks_ConfigFragmentDoc = gql`
    fragment ConfigBookmarks_config on ConfigurationModel {
  id
  bookmarks {
    all {
      reported
    }
  }
}
    `;
export const ConfigUpdateBookmarksDocument = gql`
    mutation ConfigUpdateBookmarks($input: ConfigurationUpdateBookmarksAllInput!) {
  configurationUpdateBookmarksAll(input: $input) {
    id
    ...ConfigBookmarks_config
  }
}
    ${ConfigBookmarks_ConfigFragmentDoc}`;
export type ConfigUpdateBookmarksMutationFn = ApolloReactCommon.MutationFunction<ConfigUpdateBookmarksMutation, ConfigUpdateBookmarksMutationVariables>;

/**
 * __useConfigUpdateBookmarksMutation__
 *
 * To run a mutation, you first call `useConfigUpdateBookmarksMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useConfigUpdateBookmarksMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [configUpdateBookmarksMutation, { data, loading, error }] = useConfigUpdateBookmarksMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useConfigUpdateBookmarksMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<ConfigUpdateBookmarksMutation, ConfigUpdateBookmarksMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<ConfigUpdateBookmarksMutation, ConfigUpdateBookmarksMutationVariables>(ConfigUpdateBookmarksDocument, options);
      }
export type ConfigUpdateBookmarksMutationHookResult = ReturnType<typeof useConfigUpdateBookmarksMutation>;
export type ConfigUpdateBookmarksMutationResult = ApolloReactCommon.MutationResult<ConfigUpdateBookmarksMutation>;
export type ConfigUpdateBookmarksMutationOptions = ApolloReactCommon.BaseMutationOptions<ConfigUpdateBookmarksMutation, ConfigUpdateBookmarksMutationVariables>;